import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { City } from '@app/core/models/city.model';
import { EnvironmentService } from '@app/core/services/environment-service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CityService {
    private http = inject(HttpClient);
    private env = inject(EnvironmentService);
    private router = inject(Router);

    cities = this.http.get<City[]>(this.env.apiURL + '/dashboard-cities').pipe(
        catchError((e) => {
            console.error(e);
            this.router.navigate(['/error']);
            return of([]);
        }),
    );

    deleteCityAccount(cityId: string, accountId: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.env.apiURL}/dashboard-cities/${cityId}/accounts/${accountId}`, {
            observe: 'response',
        });
    }

    deleteCityEmail(cityId: string, emailId: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.env.apiURL}/dashboard-cities/${cityId}/emails/${emailId}`, {
            observe: 'response',
        });
    }

    updateCityInformation(
        city: Omit<City, 'supportsCorporateVouchers' | 'corporateVoucherTypeId'>,
    ): Observable<HttpResponse<City>> {
        return this.http.put<City>(
            `${this.env.apiURL}/dashboard-cities/${city.id}`,
            {
                ...city,
            },
            { observe: 'response' },
        );
    }
}
